export const SET_SUCCESS_REGISTRATION_SUCCESS = 'SET_SUCCESS_REGISTRATION_SUCCESS';
export const SET_SUCCESS_REGISTRATION_REQUEST = 'SET_SUCCESS_REGISTRATION_REQUEST';
export const SET_SUCCESS_REGISTRATION_FAILED = 'SET_SUCCESS_REGISTRATION_FAILED';
